import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c90c690"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "photomodel-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "common-h1" }, "Фотомодели", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Добавить новую модель", -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Добавить модель")
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Активные модели", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Архив моделей", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_el_form, {
      size: "small",
      "label-position": "top",
      style: {"max-width":"460px","width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "Имя" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              "model-value": _ctx.addForm.name,
              "onUpdate:model-value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.addForm.name) = $event)),
              maxlength: 127
            }, null, 8, ["model-value"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "Пол" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.addForm.gender,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.addForm.gender) = $event)),
              class: "m-2",
              placeholder: "Select",
              size: "large"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genders, (gender) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: gender.value,
                    label: gender.label,
                    value: gender.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "Рост (см)" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.addForm.height,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addForm.height) = $event)),
              maxlength: 3
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "Грудь (см)" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.addForm.chest,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addForm.chest) = $event)),
              maxlength: 3
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "Талия (см)" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.addForm.waist,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.addForm.waist) = $event)),
              maxlength: 3
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "Бедра (см)" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.addForm.hips,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.addForm.hips) = $event)),
              maxlength: 3
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, { onClick: _ctx.createPhotomodel }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    (_ctx.errorMsg)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "photomodel-page__error-msg",
          innerHTML: _ctx.errorMsg
        }, null, 8, _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.activePhotomodels && _ctx.activePhotomodels.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activePhotomodels, (photomodel) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "photomodel-page__model",
              key: photomodel.id
            }, [
              _createTextVNode(_toDisplayString(photomodel.name) + " (" + _toDisplayString(_ctx.getGenderByNumber(photomodel.gender)) + ") ", 1),
              _hoisted_7,
              _createTextVNode(" Рост - " + _toDisplayString(photomodel.height) + ", грудь - " + _toDisplayString(photomodel.chest) + ", талия - " + _toDisplayString(photomodel.waist) + ", бедра - " + _toDisplayString(photomodel.hips) + " ", 1),
              _hoisted_8,
              _createElementVNode("span", {
                onClick: ($event: any) => (_ctx.setArchivePhotomodel(photomodel.id))
              }, "В архив", 8, _hoisted_9)
            ]))
          }), 128))
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.archivePhotomodels && _ctx.archivePhotomodels.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _hoisted_10,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.archivePhotomodels, (photomodel) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "photomodel-page__model",
              key: photomodel.id
            }, [
              _createTextVNode(_toDisplayString(photomodel.name) + " (" + _toDisplayString(_ctx.getGenderByNumber(photomodel.gender)) + ") ", 1),
              _hoisted_11,
              _createTextVNode(" Рост - " + _toDisplayString(photomodel.height) + ", грудь - " + _toDisplayString(photomodel.chest) + ", талия - " + _toDisplayString(photomodel.waist) + ", бедра - " + _toDisplayString(photomodel.hips) + " ", 1),
              _hoisted_12,
              _createElementVNode("span", {
                onClick: ($event: any) => (_ctx.setActivePhotomodel(photomodel.id))
              }, "Активировать", 8, _hoisted_13)
            ]))
          }), 128))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}